<div #stageOuterContainer class="presenter-view-root">
  <gb-presenter-canvas
    [responsive]="true"
    [draggable]="false"
    [inPreviewMode]="true"
    [backgroundColor]="backgroundColor$ | async"
    [backgroundImage]="backgroundImageUrl$ | async"
    [backgroundImageCover]="backgroundImageCover$ | async"
    [customCss]="customCss$ | async"
    (deselectWidget)="onGeneralClick()"
  ></gb-presenter-canvas>

  @if (!previewMode && !thumbnailPreview) {
    <div [class.is-fullscreen]="isFullscreen$ | async" class="presenter-view-fullscreen-hotzone">
      <button
        class="presenter-view-fullscreen-button"
        matFab
        extended
        type="button"
        (click)="toggleFullscreen(); $event.stopPropagation()"
      >
        <div class="fullscreen-button-inner">
          @if (isFullscreen$ | async) {
            <gb-icon icon="contract"></gb-icon>
            <span>
              {{ 'PRESENTER.EXIT_FULL_SCREEN' | translate }}
            </span>
          } @else {
            <gb-icon icon="expand"></gb-icon>
            <span>
              {{ 'PRESENTER.GO_FULL_SCREEN' | translate }}
            </span>
          }
        </div>
      </button>
    </div>
  }

  @if (previewMode) {
    <button class="close-preview-button" matFab extended type="button">
      <div class="close-preview-button-inner">
        <gb-icon icon="close"></gb-icon>
        <span>
          {{ 'PRESENTER.CLOSE_PREVIEW' | translate }}
        </span>
      </div>
    </button>
  }

  @if (!thumbnailPreview) {
    <div class="presenter-view-slide-nav-hotzone">
      <div class="presenter-view-slide-nav" [class.nav-visible]="navVisible()" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="presenter-view-slide-nav-button"
          [disabled]="(canGoPreviousSlide$ | async) === false"
          (click)="selectPreviousSlide(); $event.stopPropagation()"
          aria-label="Previous slide"
        >
          <gb-icon icon="keyboard_arrow_left" [library]="IconLibrary.material"></gb-icon>
        </button>

        <div class="presenter-view-slide-nav-index">{{ currentSlideDisplayIndex$ | async }}</div>

        <button
          type="button"
          class="presenter-view-slide-nav-button"
          [disabled]="(canGoNextSlide$ | async) === false"
          (click)="selectNextSlide(); $event.stopPropagation()"
          aria-label="Next slide"
        >
          <gb-icon icon="keyboard_arrow_right" [library]="IconLibrary.material"></gb-icon>
        </button>
      </div>
    </div>
  }
</div>
